import api from './api'

export const filterService = {
  // Obtener todos los colores
  getColors: async () => {
    const response = await api.get('/filters/colors')
    return response.data
  },

  // Obtener todos los materiales
  getMaterials: async () => {
    const response = await api.get('/filters/materials')
    return response.data
  },

  // Obtener todos los cristales
  getCrystals: async () => {
    const response = await api.get('/filters/crystals')
    return response.data
  }
}

export default filterService